module.exports = __webpack_public_path__ + "static/media/Artboard18.0c5a7d31.png";